import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Table,
  DropdownItem,
  DropdownMenu,
  UncontrolledCollapse,
  DropdownToggle,
  Dropdown,
  FormGroup,
  Input,
  Tooltip,
} from "reactstrap";
import AgencyImage from "../../../constants/Images/defaultAgency-1.png";
import {
  ADMIN_PAYMENT_REPORT,
  STATE_LIST,
  AGENCY_LIST,
} from "../../../constants/ApiPaths";
import API from "../../../redux/actions/API";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import { authHeader } from "../../../functions/CoreFunctions";
import Pagination from "../../common/Pagination";
import Select from "react-select";
import { debounce } from "underscore";
import moment from "moment";
import { CSVLink } from "react-csv";
import generatePDF from "./PaymentReportGenertor";
import { Info } from "../../common/Info";

function PaymentReport() {
  const [loading, setLoading] = useState(false);
  const [paymentReport, setPaymentReport] = useState([]);
  const [totalRecords, setTotalRecords] = useState("");
  const [currentpage, setCurrentPage] = useState(0);
  
  const rowperpage = 10;

  const [options, setoptions] = useState([]);
  const selectInputRef = useRef();
  const [selectagency, setselectagency] = useState("");
  const [agencyId, setagencyId] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [filterState, setfilterState] = useState("");
  const [SelectState, setSelectState] = useState([]);
  const [licensetype, setlicensetype] = useState("");
  const [paymentType, setpaymentType] = useState("");
  const [dropdownOpen, setdropdownOpen] = useState(false);
  const toggle = () => {
    setdropdownOpen(!dropdownOpen);
  };
  const [validFromDate, setvalidFromDate] = useState("");
  const [validToDate, setvalidToDate] = useState("");
  const [data, setdata] = useState([]);
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  const headers = [
    { label: "Agency Name", key: "agencyName" },
    { label: "Agency Email", key: "agencyEmail" },
    { label: "Type of License", key: "typeofLicense" },
    { label: "Payment Type", key: "paymentType" },
    { label: "Payment Status", key: "paymentStatus" },
    { label: "Payment Date", key: "paymentDate" },
    { label: "Total Amount", key: "totalAmount" },
  ];

  const getAdminReport = async (
    agencyId,
    paymentDate,
    filterState,
    licensetype,
    paymentType,
    validFromDate,
    validToDate
  ) => {
    setLoading(true);
    const config = {
      method: "GET",
      url: ADMIN_PAYMENT_REPORT,
      headers: authHeader(),
      params: {
        offset: currentpage,
        count: rowperpage,
        agencyId: agencyId,
        paymentDate: paymentDate,
        stateId: filterState,
        typeOfLicense: licensetype,
        paymentType: paymentType,
        validFromDate: validFromDate,
        validToDate: validToDate,
      },
    };
    try {
      const response = await API(config);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        setPaymentReport(data);
        const value = data.map((data) => ({
          agencyName: data.agencyName,
          agencyEmail: data.agencyEmail,
          typeofLicense: data.typeofLicense,
          paymentType: data.paymentType,
          paymentStatus: data.paymentStatus,
          paymentDate: data.paymentDate,
          totalAmount: data.totalAmount,
        }));
        setdata(value);
        setTotalRecords(totalCount);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const getAgency = async (selectagency) => {
    const config = {
      method: "GET",
      url: AGENCY_LIST,
      headers: authHeader(),
      params: {
        count: 10,
        agencyName: selectagency,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setoptions(
          data.map((d) => ({ value: d.agencyId, label: d.agencyName }))
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const GetState = async () => {
    const config = {
      method: "GET",
      url: STATE_LIST,
      headers: authHeader(),
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        setSelectState(data);
      }
    } catch (error) {
      console.error(error);
    } finally {
    }
  };

  const OptionHandle = (e) => {
    if (e !== null) {
      const { value } = e;
      setCurrentPage(0);
      setagencyId(value);
    } else {
      setselectagency("");
      setagencyId("");
      setCurrentPage(0);
    }
  };
  const OptionInputHandle = (text) => {
    setCurrentPage(0);

    setselectagency(text);
  };

  const datefilterHandle = (e) => {
    setCurrentPage(0);
    setPaymentDate(moment(e.target.value).format("MM/DD/YY"));
  };

  const dateFromfilterHandle = (e) => {
    setCurrentPage(0);
    setvalidFromDate(moment(e.target.value).format("MM/DD/YY"));
  };

  const dateTofilterHandle = (e) => {
    setCurrentPage(0);
    setvalidToDate(moment(e.target.value).format("MM/DD/YY"));
  };

  const AgencySearch = useRef(
    debounce((selectagency) => getAgency(selectagency))
  ).current;

  const stateFiltreHandle = (e) => {
    setCurrentPage(0);
    setfilterState(e.target.value);
  };

  const licensetypeHandle = (e) => {
    setCurrentPage(0);
    setlicensetype(e.target.value);
  };

  const paymetnHandle = (e) => {
    setCurrentPage(0);
    setpaymentType(e.target.value);
  };

  useEffect(() => {
    AgencySearch(selectagency);
  }, [selectagency]);

  const onPageChange = (page) => {
    // setagencyId(agencyId);
    setCurrentPage(page - 1);
  };

  const clean = () => {
    setagencyId("");
    setPaymentDate("");
    selectInputRef.current?.select?.clearValue();
    setlicensetype("");
    setpaymentType("");
    setfilterState("");
    setvalidToDate("");
    setvalidFromDate("");
  };

  const Filter = useRef(
    debounce(
      (
        agencyId,
        paymentDate,
        filterState,
        licensetype,
        paymentType,
        validFromDate,
        validToDate
      ) =>
        getAdminReport(
          agencyId,
          paymentDate,
          filterState,
          licensetype,
          paymentType,
          validFromDate,
          validToDate
        )
    )
  ).current;
  useEffect(() => {

    Filter(
      agencyId,
      paymentDate,
      filterState,
      licensetype,
      paymentType,
      validFromDate,
      validToDate
    );
  }, [
    agencyId,
    paymentDate,
    filterState,
    licensetype,
    paymentType,
    validFromDate,
    validToDate,
  ]);

  useEffect(() => {
    GetState();
  }, []);

  useEffect(() => {
    getAdminReport(
      getAdminReport(
        agencyId,
        paymentDate,
        filterState,
        licensetype,
        paymentType,
        validFromDate,
        validToDate
      )
    );
  }, [currentpage]);

  const Generate = () => {
    generatePDF(paymentReport);
  };
  return (
    <div>
      {loading && <CustomPageLoading />}

      <div className="wrapper">
        <Container fluid>
          <div className="page-title">
            <h4>
              Payment Report
              <Tooltip
                isOpen={id === "paymentreport" && tooltipOpen}
                target={"paymentreport"}
                toggle={() => tooltiptoggle("paymentreport")}
              >
                Report of all payment transactions
              </Tooltip>
              <span id={"paymentreport"}>
                <Info />
              </span>
            </h4>

            <div className="top-btn">
              <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle color="danger" caret>
                  Export
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={Generate}>PDF</DropdownItem>

                  <DropdownItem>
                    <CSVLink
                      filename={"Paymentreport.csv"}
                      data={data}
                      headers={headers}
                    >
                      CSV
                    </CSVLink>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
              <Button id="toggler" color="link">
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14.371"
                  height="14.371"
                  viewBox="0 0 14.371 14.371"
                >
                  <path
                    id="Icon_awesome-filter"
                    data-name="Icon awesome-filter"
                    d="M13.7,0H.674A.674.674,0,0,0,.2,1.15L5.389,6.342v5.784a.674.674,0,0,0,.287.552l2.246,1.571a.674.674,0,0,0,1.06-.552V6.342L14.173,1.15A.674.674,0,0,0,13.7,0Z"
                    fill="#1b3e6f"
                  />
                </svg>
              </Button>
            </div>
          </div>

          <div className="mt-4">
            <UncontrolledCollapse toggler="#toggler">
              <Card body>
                <Row className="mt-3">
                  <Col md="4" lg="4" xl="3">
                    <FormGroup>
                      <span>Select Agency</span>
                      <Select
                        options={options}
                        isClearable={true}
                        ref={selectInputRef}
                        placeholder="Select Agency"
                        onChange={OptionHandle}
                        onInputChange={OptionInputHandle}
                      />
                    </FormGroup>
                  </Col>

                  <Col md="4" lg="4" xl="3">
                    <FormGroup>
                      <span>Select State</span>
                      <Input
                        type="select"
                        name="stateId"
                        value={filterState}
                        onChange={stateFiltreHandle}
                        id=""
                        placeholder="Enter hyperlink"
                      >
                        <option value="">Select State</option>
                        {SelectState.map((i) => (
                          <option key={i.stateId} value={i.stateId}>
                            {i.stateName}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>

                  <Col md="4" lg="4" xl="3">
                    <FormGroup>
                      <span>Select License Type</span>
                      <Input
                        type="select"
                        name="stateId"
                        value={licensetype}
                        onChange={licensetypeHandle}
                        id=""
                        placeholder="Enter hyperlink"
                      >
                        <option value="">Select License Type</option>
                        {["Kennel License", "Park License", "Dog License"].map(
                          (i) => (
                            <option key={i} value={i}>
                              {i}
                            </option>
                          )
                        )}
                      </Input>
                    </FormGroup>
                  </Col>

                  <Col md="4" lg="4" xl="3">
                    <FormGroup>
                      <span>Select Payment Type</span>
                      <Input
                        type="select"
                        name="stateId"
                        value={paymentType}
                        onChange={paymetnHandle}
                        id=""
                        placeholder="Enter hyperlink"
                      >
                        <option value="">Select Payment Type</option>
                        {["Debit Card", "Swipe"].map((i) => (
                          <option key={i} value={i}>
                            {i}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md="4" lg="4" xl="3">
                    <span>Payment Date</span>
                    <FormGroup>
                      <Input
                        type="date"
                        onChange={datefilterHandle}
                        value={moment(paymentDate).format("YYYY-MM-DD")}
                        name=""
                        id=""
                        placeholder="Email"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4" lg="4" xl="3">
                    <FormGroup>
                      <span>Valid From</span>
                      <Input
                        type="date"
                        placeholder="MM/DD/YYYY"
                        value={moment(validFromDate).format("YYYY-MM-DD")}
                        onChange={dateFromfilterHandle}
                        name=""
                        id=""
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4" lg="4" xl="3">
                    <FormGroup>
                      <span>Valid To</span>
                      <Input
                        type="date"
                        placeholder="MM/DD/YYYY"
                        value={moment(validToDate).format("YYYY-MM-DD")}
                        onChange={dateTofilterHandle}
                        name=""
                        id=""
                      />
                    </FormGroup>
                  </Col>
                  <Col md="4" lg="4" xl="3" className="my-auto">
                    <Button color="danger" className="mt-2" onClick={clean}>
                      Clear
                    </Button>
                  </Col>
                </Row>
              </Card>
            </UncontrolledCollapse>
          </div>

          <Card body className="mt-4">
            <Table hover responsive>
              <thead>
                <tr>
                  <th>Payment Date</th>
                  <th>Logo</th>
                  <th>Agency Name</th>
                  <th>Agency Email</th>
                  <th>State</th>
                  <th>License Type</th>
                  <th>Payment Type</th>
                  <th>Payment</th>
                  <th>Total Amount</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  ""
                ) : (
                  <>
                    {paymentReport.length === 0 ? (
                      <tr>
                        <td colSpan={9}>
                          <center>No Record Found</center>
                        </td>
                      </tr>
                    ) : (
                      <>
                        {paymentReport.map((report, index) => (
                          <tr>
                            <td>{report.paymentDate}</td>
                            <td>
                              {" "}
                              <div className="user-box">
                                <img
                                  style={{ marginRight: "8px" }}
                                  alt=""
                                  src={
                                    report.agencyLogo
                                      ? AgencyImage
                                      : report.agencyLogo
                                  }
                                />
                              </div>
                            </td>
                            <td>{report.agencyName} </td>
                            <td>{report.agencyEmail}</td>
                            <td>{report.stateName}</td>
                            <td>{report.typeofLicense}</td>
                            <td>{report.paymentType}</td>
                            <td>{report.paymentStatus}</td>
                            <td>
                              ${parseFloat(report.totalAmount || 0).toFixed(2)}
                            </td>
                          </tr>
                        ))}
                      </>
                    )}{" "}
                  </>
                )}
              </tbody>
            </Table>
            <div className="d-flex flex-row py-4 justify-content-end">
              <Pagination
                itemClass="page-item"
                linkClass="page-link"
                activePage={currentpage + 1}
                itemsCountPerPage={rowperpage}
                totalItemsCount={totalRecords}
                onChange={onPageChange}
              />
            </div>
          </Card>
        </Container>
      </div>
    </div>
  );
}

export default PaymentReport;
